import { CompletedAppointments } from "@/features/appointments/CompletedAppointments";
import { Drawings } from "@/features/drawings/Drawings";
import { getProjectDrawings } from "@/features/drawings/DrawingsSection";
import { Tasks } from "@/features/tasks/Tasks";
import { type Opportunity } from "@repo/api";
import { Tab, TabPanel, Tabs } from "@repo/skapa";
import { t } from "@repo/translation";

import { Orders } from "../orders/order/Orders";

export const ProjectDetailsTabs = ({
  opportunity,
}: {
  opportunity: Opportunity;
}) => {
  const projectDrawings = getProjectDrawings(opportunity);

  return (
    <Tabs
      tabs={[
        <Tab
          key="project-details-upcoming__tab"
          text={t("label.upcoming")}
          tabPanelId="project-details-upcoming"
        />,
        <Tab
          key="project-details-completed__tab"
          text={t("label.completed")}
          tabPanelId="project-details-completed"
        />,
        <Tab
          key="project-details-orders__tab"
          text={t("label.orders")}
          tabPanelId="project-details-orders"
        />,
        <Tab
          key="project-details-drawings__tab"
          text={t("label.drawings")}
          tabPanelId="project-details-drawings"
        />,
      ]}
      tabPanels={[
        <TabPanel
          tabPanelId="project-details-upcoming"
          key="project-details-upcoming__tabpanel"
        >
          <Tasks opportunity={opportunity} editable={false} context="PROJECT" />
        </TabPanel>,

        <TabPanel
          tabPanelId="project-details-completed"
          key="project-details-completed__tabpanel"
        >
          <CompletedAppointments opportunityId={opportunity.id} editable />
        </TabPanel>,

        <TabPanel
          tabPanelId="project-details-orders"
          key="project-details-orders__tabpanel"
        >
          <Orders editable={false} />
        </TabPanel>,
        <TabPanel
          tabPanelId="project-details-drawings"
          key="project-details-drawings__tabpanel"
        >
          <Drawings
            drawings={projectDrawings?.drawings}
            designs={projectDrawings?.designs}
          />
        </TabPanel>,
      ]}
    />
  );
};
